import { useEffect, useMemo, useState } from "react";

import { HubHookFormWrapper } from "../../components";
import {
  EmployeeScanContextProvider,
  useEmployeeScanContext,
} from "../../hooks/contexts/EmployeeScanContextProvider";
import { WorkOrderBase } from "../../containers/WorkOrder/WorkOrderBase";
import WorkOrderMain from "./WorkOrderMain";
import WorkOrderBar from "./WorkOrderBar";
import WorkOrderNav from "./WorkOrderNav";

import { StyleDisplayStack } from "./styles";
import { getDefaultValues, tabs } from "./helper";
import { updateWorkOrderInstructionsMapper } from "./helperV2";

const formSx = { height: "100%", overflow: "hidden" };
const printSheetSx = { position: "absolute", left: "-9999px" };

// Inner has access to the scan context.
const WorkOrderContentInner = ({
  id,
  data,
  setPayload,
  handleCloseWorkOrder,
  setUseScanEndpoint,
}) => {
  const [value, setValue] = useState(1);
  const [showCompleted, setShowCompleted] = useState(true);

  const { isScanned, scannedEmployee, shouldShowScan } =
    useEmployeeScanContext();

  // Scan endpoint only applies to the Routing & Labor tab.
  useEffect(() => {
    const isRoutingTab = value === 1;
    setUseScanEndpoint(isRoutingTab && (isScanned || shouldShowScan));
  }, [value, isScanned, shouldShowScan, setUseScanEndpoint]);

  const defaultValues = useMemo(() => getDefaultValues(data), [data]);

  const ActiveTab = useMemo(
    () => tabs.find((t) => t.id === value)?.TabElement || (() => null),
    [value],
  );

  const partId = data?.part?.id;
  const locationId = data?.lineItem?.locationId;
  const workOrderId = data?.id;

  const onFormSubmit = (formData) => {
    const built = updateWorkOrderInstructionsMapper(
      formData,
      defaultValues,
      id,
    );

    console.log(built);
    setPayload({
      ...built,
      ...(value === 1 &&
        scannedEmployee?.userId && { scannedUserId: scannedEmployee.userId }),
    });
  };

  return (
    <>
      <HubHookFormWrapper
        onSubmit={onFormSubmit}
        sx={formSx}
        defaultValues={defaultValues}
      >
        <WorkOrderBar
          workOrder={data?.workOrder}
          onCloseWorkOrder={handleCloseWorkOrder}
          status={data?.status}
          state={data?.state}
          showCompleted={showCompleted}
          setShowCompleted={setShowCompleted}
        />
        <StyleDisplayStack>
          <WorkOrderNav value={value} setValue={setValue} />
          <ActiveTab
            key={id}
            id={id}
            data={data}
            partId={partId}
            locationId={locationId}
            workOrderId={workOrderId}
            instructions={data?.instructions}
            partInstructions={data?.partInstructions}
            showCompleted={showCompleted}
          />
          <WorkOrderMain data={data} workOrder={id} />
        </StyleDisplayStack>
      </HubHookFormWrapper>
      <WorkOrderBase
        id="traverler-sheet"
        data={data}
        isLoading={false}
        sx={printSheetSx}
      />
    </>
  );
};

const WorkOrderContent = (props) => {
  const locationId = props.data?.lineItem?.locationId;
  return (
    <EmployeeScanContextProvider
      workOrderId={props.data?.workOrder}
      locationId={locationId}
    >
      <WorkOrderContentInner {...props} />
    </EmployeeScanContextProvider>
  );
};

export default WorkOrderContent;
